<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate @input="productAcivateUpdateFlag('details')">
                        <div class="d-flex justify-content-end align-items-center my-4 px-4">
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" :disabled="$v.form.$invalid" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" :disabled="$v.form.$invalid" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">
                            <!-- <div class="row">
                                <div class="col-sm-12">
                                    <label class="full">
                                        Active
                                        <toggle-button
                                        v-model="form.active"
                                        :labels="{checked: 'YES', unchecked: 'NO'}"/>
                                    </label>
                                </div>
                            </div> -->

                            <div class="row">
                                <div class="col-sm-7">

                                    <add-image @imageChanged="imageChanged" :currentImage="(this.form.imageLogo)? this.form.imageLogo : this.form.imageLogoBase64"></add-image>

                                    <div class="panel mt-0 shaded radius-top-left-none radius-top-right-none">
                                        <div class="form-group row">
                                            <div class="col-sm-8" :class="{ error: $v.form.name.$error }">
                                                <label class="full">
                                                    Product name
                                                    <span class="brand">
                                                        *
                                                    </span>
                                                    <input type="text" v-model="form.name" @input="$v.form.name.$touch">
                                                </label>

                                                <div v-if="$v.form.name.$error" class="messages">
                                                    <span v-if="!$v.form.name.required">Name is required.</span>
                                                    <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="full">
                                                    Code
                                                    <input type="text" v-model="form.code">
                                                </label>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-7">
                                                <div v-if="getCategories">
                                                    <label class="full">Product categories<span class="brand">*</span></label>

                                                    <multiselect
                                                        v-model="form.categoryList"
                                                        :searchable="false"
                                                        :options="categories"
                                                        :multiple="true"
                                                        :taggable="true"
                                                        @input="categoriesChanged"
                                                        track-by="id"
                                                        label="name"
                                                        selectLabel=""
                                                        deselectLabel=""
                                                    >
                                                    </multiselect>

                                                </div>

                                            </div>


                                            <div v-if="getEventColors" class="col-sm-5">
                                                <label class="full">
                                                    Color
                                                </label>

                                                <color-picker :selectedId="form.color" @colorChanged="updateColor" :colors="getEventColors"></color-picker>
                                            </div>

                                        </div>

                                        <div class="form-group row my-4">
                                            <div class="col-sm-12">
                                                <checkbox v-model="form.isPrivate" @input="changePrivateStatus">
                                                    Private tour / Charter.
                                                    <span class="normal">
                                                        Only one booking per tour is allowed.
                                                    </span>
                                                </checkbox>
                                            </div>
                                        </div>

                                    </div>



                                    <div class="panel shaded">

                                        <h5>Description</h5>

                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <label class="full">
                                                    Brief description
                                                    <input type="text" v-model="form.descriptionBrief">
                                                </label>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <label class="full">
                                                    Product description
                                                </label>
                                                <textarea rows="8" v-model="form.description"></textarea>
                                                <!-- <vue-editor class="darkest" v-model="form.description" :editorToolbar="customToolbar" placeholder="Enter a small description for this product"></vue-editor> -->
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <label class="full">
                                                    Ticket information (Terms and conditions, Checkin information, Others)
                                                </label>
                                                <textarea v-model="form.descriptionMore" rows="30" placeholder="e.g. Cancellations and changes accepted up to 48 hours before the event"></textarea>
                                                <!-- <vue-editor class="darkest" v-model="form.descriptionMore" :editorToolbar="customToolbar" placeholder="e.g. Cancellations and changes accepted up to 48 hours before the event"></vue-editor> -->
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div class="col-sm-5">
                                    <div class="panel shaded mt-0" :class="{ error: $v.form.location.$error }">
                                        <h5>Location <span class="brand">*</span></h5>


                                        <label class="full">
                                            <input type="text" v-model="form.location" @input="$v.form.location.$touch" placeholder="e.g. Albufeira, Marina de Albufeira">
                                            <div class="fs-smaller normal mt-2">Insert a location or starting point for this product.</div>
                                        </label>

                                        <div v-if="$v.form.location.$error" class="messages">
                                            <span v-if="!$v.form.location.required">Location is required.</span>
                                        </div>
                                    </div>



                                    <div class="panel shaded">
                                        <h5>Notes</h5>

                                        <div class="fs-small dark mt-2 mb-3">
                                            This information will be displayed on the calendar and on new reservations page.
                                        </div>

                                        <textarea v-model="form.internalNote"></textarea>

                                    </div>

                                    <div class="panel shaded">
                                        <h5>Booking question</h5>


                                        <label class="full">
                                            <input type="text" v-model="form.bookingQuestion" placeholder="e.g. Do you have the required fishing license?">
                                            <div class="fs-smaller normal mt-2">Use this if you want to add a question to the booking process.</div>
                                        </label>

                                        <checkbox v-model="form.bookingQuestionIsActive">
                                            Is question active.
                                        </checkbox>

                                        <checkbox v-model="form.bookingQuestionIsMandatory">
                                            Is question mandatory.
                                        </checkbox>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center my-4 px-4">
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" :disabled="$v.form.$invalid" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" :disabled="$v.form.$invalid" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Steps from './ProductSteps'
    import AddImage from './ProductAddImage'
    import { required, minLength } from 'vuelidate/lib/validators'
    import ColorPicker from '@/tools/ColorPicker'
    import {eventHub} from '../../../main'
    import { VueEditor } from 'vue2-editor'
    import Multiselect from 'vue-multiselect'

    import mixpanelMixin from '@/mixins/mixpanel'

    export default {
        mixins: [
            mixpanelMixin
        ],
        props: {
            currentStep: Number
        },
        data: function() {
            return {
                step: 1,
                form: {
                    version: 1,
                    resetItemsWhenEditing: false,
                    name: null,
                    code: null,
                    bookingQuestion: null,
                    bookingQuestionIsActive: false,
                    bookingQuestionIsMandatory: false,
                    capacity: 0,
                    category: {},
                    categoryList: [],
                    color: null,
                    isPrivate: false,
                    tax: true,
                    productCommercialAvailability: 1,
                    imageLogo: null,
                    imageBase64: null,
                    hasManualConfirmation: false,
                    salesPermissionsAgents: true,
                    salesPermissionsAgentsCommissionValue: null,
                    salesPermissionsAgentsCustom: false,
                    agentsInFutureAreAllowed: true,
                    salesPermissionsTeam: true,
                    salesPermissionsWebsite: true,
                    routes:[]
                },
                selectedCategory: null,
                selectedProductCommercialAvailability: null,
                selectedColor: null,
                selectedPrincingType: null,
                updateFlagsEnabled: false,
                customToolbar: [
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    ["bold", "italic", "underline", "strike"], // toggled buttons
                    [
                        { align: "" },
                        { align: "center" },
                        { align: "right" },
                        { align: "justify" }
                    ],
                    // ["blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                    // ["link", "image", "video"],
                    ["clean"] // remove formatting button
                ]
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
                categoryList: {
                    required,
                    minLength: minLength(1)
                },
                location: {
                    required
                }
                // capacity: {
                //     required,
                //     minLength: minLength(1)
                // }
            }
        },
        mounted: function() {
        },
        created: function() {
            if (this.getSelectedItem && !this.getClonedItem) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedItem));
                // this.$set(this, 'form', JSON.parse(JSON.stringify(this.getSelectedItem)))
            } else if(this.getClonedItem){
                // EDITING PRODUCT
                this.form = this.getClonedItem
            } else {
                // CREATE PRODUCT
                this.form.active = true;
                this.updateType({id:1});

                // add sales channel info
                this.$set(this.form, 'channelCommissions', JSON.parse(JSON.stringify(this.getSalesChannelsForNewProduct)))
            }

            // helepr bus to force update, prevents pricing not being updated after change on split price modal
            eventHub.$on('forceUpdate',() => {
                this.$forceUpdate();
            });

            //if flag salesPermissionsAgentsCustom is not set, we set as false
            if(this.form.salesPermissionsAgentsCustom == undefined ){
                this.$set(this.form, 'salesPermissionsAgentsCustom', false)
            }

            //if salesPermissionsAgentsCommissionValue is not set, we set as to the agent defult:
            // if(this.form.salesPermissionsAgentsCommissionValue == undefined || this.form.salesPermissionsAgentsCommissionValue == null ){
            //     this.$set(this.form, 'salesPermissionsAgentsCommissionValue', this.account.supplier.settingsPresets.commissionAgentsProduct)
            // }
            //if there is no agentsInFutureAreAllowed (yes = treu | no = false) we set it to true
            if(this.form.agentsInFutureAreAllowed == undefined){
                this.$set(this.form, 'agentsInFutureAreAllowed', true)
            }

            // sets Name, from, to, duration
            // without this, if we edit an existing product and jump to step "pickups" and press save, the groups will not have any dates and times (api will return error)
            // this ternary operator allows to return to step 1 from step 2 when creating and still having the dateFrom dateTo etc
            if(this.form.groups){
                this.form.groups.map(group => {
                    if(group.schedules[0]){
                        group.dateFrom = group.schedules[0].dateFrom? group.schedules[0].dateFrom : group.dateFrom
                        group.dateTo = group.schedules[0].dateTo? group.schedules[0].dateTo : group.dateTo
                        group.duration = group.schedules[0].duration? group.schedules[0].duration : group.duration
                    }
                })
            }

            // setting VAT Type
            if(this.form.productGenderPrices){
                for (let pricingRow of this.form.productGenderPrices) {
                    //if(pricingRow.genderPriceType == 2){
                        pricingRow.vatTypeHelper = this.taxes.filter((audienceType) => {
                            return audienceType.id == pricingRow.vatType;
                        })[0]
                    //}
                }
            }

            // enable updateFlags
            this.updateFlagsEnabled = true

            this.setStartingColor()

            this.setStartingCategory()
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'account',
                'getSalesChannelsForNewProduct',
                'getVatTypes',
                'getAudienceTypeList',
                'getEventColors',
                'getCategories',
            ]),
            categories: function () {
                return this.getCategories
            },
            taxes: function () {
                return this.getVatTypes
            },
            isPricePerOrder: function(){
                if(this.selectedPrincingType !== null && this.selectedPrincingType.id == 1 || this.form.productGenderPrices[0].genderPriceType == 1){
                    return true;
                } else {
                    return false;
                }
            },
            audienceTypes: function () {
                return this.getAudienceTypeList
            }
        },
        methods: {
            ...mapActions([
                'initCategories',
                'openModal',
                'updateroductEditPriceData'
            ]),
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                // this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
                this.$emit('goToStep', { invalid: false, form: this.form, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
                this.trackSaveChanges('Product', this.form.id, this.form.name)
            },
            categoriesChanged: function(e) {
                this.productAcivateUpdateFlag('details')
            },
            setStartingColor: function () {
                if(this.getEventColors.length == 0){
                    return false
                }


                if (this.form.color !== undefined && this.form.color !== null) {
                    this.selectedColor = this.getEventColors.find(item => item.id === this.form.color);
                }
                else {
                    this.selectedColor = this.getEventColors[0];
                    this.form.color = this.getEventColors[0].id;
                }
            },
            updateColor: function(color) {
                this.productAcivateUpdateFlag('details')
                this.form.color = color.id || null;
                this.$forceUpdate();
            },
            imageChanged: function(imageBase64){
                this.productAcivateUpdateFlag('details')
                this.form.imageLogoBase64 = imageBase64;
            },
            setStartingCategory: function () {
                if (this.form.category !== undefined && this.form.category !== {}) {
                    this.selectedCategory = this.getCategories.find(item => item.id === this.form.category.id);
                }
                else {
                    this.selectedCategory = this.getCategories[0];
                    this.form.category = this.getCategories[0];
                }
            },
            updateType: function(selectedType){
                console.log('running updateType');
                if(selectedType.id == 1){
                    if(this.form.productGenderPrices === undefined || this.form.productGenderPrices[0].genderPriceType != 1){
                        console.log('setting princing to one row Per Order');
                        this.$set(this.form, 'productGenderPrices', [
                            {
                                genderPriceType: 1,
                                vatType: 0,
                                value: 0,
                                currency: "€"
                            }
                        ])
                    }
                } else {
                    try{
                        console.log('setting princing to one row Per Person');
                        //if(this.form.productGenderPrices.productGenderPriceComponents && this.form.productGenderPrices.productGenderPriceComponents.length == 0){
                            this.$set(this.form, 'productGenderPrices', [
                                {
                                    genderPriceType: 2,
                                    audienceType: this.audienceTypes[0].id,
                                    audienceTypeHelper: this.audienceTypes[0],
                                    value: 0,
                                    currency: '€',
                                    vatType: this.taxes[0].id,
                                    vatTypeHelper: this.taxes[0],
                                    productGenderPriceComponents: [
                                    ]
                                }
                            ])
                            // this.form.productGenderPrices = [
                            //     {
                            //         genderPriceType: 2,
                            //         audienceType: this.audienceTypes[0].id,
                            //         audienceTypeHelper: this.audienceTypes[0],
                            //         value: 0,
                            //         currency: '€',
                            //         vatType: this.taxes[0].id,
                            //         vatTypeHelper: this.taxes[0],
                            //         productGenderPriceComponents: [
                            //         ]
                            //     }
                            // ]
                        //}
                    } catch (err) {

                    }
                }

            },
            updateAudienceType: function(row, selectedAudienceType){
                row.audienceType = selectedAudienceType.id;
            },
            updateTaxType: function(row, selectedVatType){
                row.vatType = selectedVatType.id;
            },
            addRow: function() {
                console.log('clicked add row');
                let defaultRow = {
                    genderPriceType: 2,
                    audienceType: this.audienceTypes[0].id,
                    audienceTypeHelper: this.audienceTypes[0],
                    value: 0,
                    currency: '€',
                    vatType: this.taxes[0].id,
                    vatTypeHelper: this.taxes[0],
                    productGenderPriceComponents: []
                }


                this.form.productGenderPrices.push(defaultRow)
                this.$forceUpdate();
            },
            removePrincingAgeRow: function(index) {
                this.form.productGenderPrices.splice(index, 1);
                this.$forceUpdate();
            },
            openEditPrice: function(priceRow) {
                this.updateroductEditPriceData(priceRow)
                this.openModal('ProductEditPrice');
            },
            customPerPersonTotal: function(row) {
                let total = 0;
                for (let service of row) {
                    total += service.component.priceTotal
                }
                return (total).toFixed(2).replace(".", ",");
            },
            taxIdToName: function(taxId){
                if(this.taxes){
                    return this.taxes.filter((tax) => {
                        return tax.id == taxId
                    })[0].description
                }
            },
            audienceTypeIdToObj: function (audienceTypeId) {
                if(audienceTypeId) {
                    return this.audienceTypes.filter((audienceType) => {
                        audienceType.id == audienceTypeId;
                    })[0]
                } else {
                    return null;
                }
            },
            customPerPersonTaxes: function(row) {
                let taxes = [];
                for (let service of row) {
                    // taxes.push(this.taxIdToName(service.component.vatType))
                    if(taxes.indexOf(service.component.vatType+'%') == -1){
                        taxes.push(service.component.vatType+'%')
                    }
                }
                return taxes.join(', ')
            },
            changePrivateStatus: function(e) {
                let vm = this
                if(e){
                    // private activates
                    if(this.form.groups && this.form.groups.length > 0){
                        //check if the product has any shared resource group
                        let hasSharedResource = false
                        this.form.groups.map(group => {
                            if(group.shareType == 1){
                                hasSharedResource = true
                            }
                        })

                        if(hasSharedResource){
                            this.$dialog.confirm('\
                            <div class="fs-larg font-weight-600 mb-4">Set product as private?</div>\
                            <div>This product has shared resources, changing it to private will set those resources as "Not Shared", continue?</span></div>')
                            .then(function () {
                                vm.form.groups.map(group => {
                                    group.shareType = 0
                                })
                            })
                            .catch(function () {
                                // pressed No
                                vm.form.isPrivate = false
                            });
                        }

                    }
                }
            },
        },
        components: {
            vSelect: extendedVSelect,
            AddImage,
            Steps,
            ColorPicker,
            VueEditor,
            Multiselect
        },
    }
</script>

<style soped lang="scss">
    @import '../../../assets/scss/_variables.scss';
    .pRelative{
        // fixes the bug that makes the page scroll to top when pressing a checkbox (the page must be scrolled down for this to happen)
        position: relative;
    }

    .colorCircle{
        width: 30px;
        height: 30px;

        &.selected{
            border-color: $dark;
            border-width: 3px;
            border-style: solid;
            text-align: center;
            padding-top: 1px;
        }

        &.selected::before{
            font-family: 'PluraloIconSet' !important;
            content: "\E911";
            color: $lightest;
            font-size: 0.7rem;
        }
    }
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?4aa4d378